










import { Component, Prop, Vue } from 'vue-property-decorator';
import { DownloadListItem } from '@/models/Presentation';
import axios from 'axios';
import PresentationService from "@/service/PresentationService";
import Base from "@/views/Base";

@Component({})
export default class DownloadThumbnail extends Base {
  @Prop({ required: true }) item!: DownloadListItem;

  VIDEO_CONTENT_TYPES = ['video/mp4', 'video/quicktime', 'video/x-msvideo', 'video/x-flv', 'video/x-matroska'];
  IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/bmp'];

  get isImage(): boolean {
    return this.IMAGE_CONTENT_TYPES.includes(this.item.fileType);
  }

  get imageThumbnailUrl(): string {
    return `${axios.defaults.baseURL}/presentation/${this.item.presentationId}/download/${this.item.uuid}/${this.user.resourceAccessToken}/thumbnail`;
  }

  get isVideo(): boolean {
    return this.VIDEO_CONTENT_TYPES.includes(this.item.fileType);
  }

}
